import * as React from 'react'
import { findDOMNode } from 'react-dom'

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
  'am-grid'?: boolean | string
  'am-grid-col'?: string
  'am-grid-row'?: string
}

type propKeys = keyof IProps

const PROPS: propKeys[] = ['am-grid', 'am-grid-col', 'am-grid-row']

/*
 React removes custom attributes from DOM and current design depend on am-grid-col and amd-grid-row attributes.
 The only way to add those is to do it directly on DOM after component mounted. That's why we need this component.
 It allows to set AmGrid custom attributes.
 */
class AmGrid extends React.Component<IProps> {
  public componentDidMount() {
    const dom = findDOMNode(this) as Element

    if (dom) {
      PROPS.forEach(attributeName => {
        if (typeof this.props[attributeName] !== 'undefined') {
          dom.setAttribute(attributeName, this.props[attributeName] as any)
        }
      })
    }
  }

  public render() {
    return <div className={this.props.className}>{this.props.children}</div>
  }
}
export default AmGrid
